import React from 'react';
import { Paper, Box, List, Divider } from '@material-ui/core';

import Price from './components/Price';
import PickUpDateInfoListItem from './components/PickUpDateInfoListItem';
import PickUpTimeInfoListItem from './components/PickUpTimeInfoListItem';
import DropOffDateInfoListItem from './components/DropOffDateInfoListItem';
import PickUpLocationInfoListItem from './components/PickUpLocationInfoListItem';
import DropOffLocationInfoListItem from './components/DropOffLocationInfoListItem';

const CarDetailsBaseInfo = ({ boxSizes }) => {
	return (
		<Paper>
			<Box {...boxSizes}>
				<List>
					<PickUpDateInfoListItem />
					<Divider />
					<PickUpTimeInfoListItem />
					<Divider />
					<DropOffDateInfoListItem />
				</List>

				<Price />

				<List>
					<PickUpLocationInfoListItem />
					<Divider />
					<DropOffLocationInfoListItem />
				</List>
			</Box>
		</Paper>
	);
};

export default CarDetailsBaseInfo;
